import { useState } from "react";
import { Menu, MenuItem, ListItemText } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { useLanguage } from "hooks/settings";
import { useAppDispatch } from "store/store";
import { changeLanguage } from "store/slices/settings";
import { languages } from "../../constants";
import { SettingsMenuButton } from "src/dashboard/components/SettingsMenuButton";

export const LanguageSelector = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const dispatch = useAppDispatch();
  const language = useLanguage();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (newLanguage: string) => {
    dispatch(changeLanguage(newLanguage));
    handleClose();
  };

  return (
    <>
      <SettingsMenuButton onClick={handleClick}>
        <LanguageIcon
          sx={{
            color: "white",
            fontSize: "1.25rem",
          }}
        />
      </SettingsMenuButton>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{ mt: 1 }}
        slotProps={{
          paper: {
            sx: {
              minWidth: 160,
            },
          },
        }}
      >
        {Object.keys(languages).map((locale) => (
          <MenuItem
            key={locale}
            onClick={() => {
              handleLanguageChange(locale);
            }}
            selected={locale === language}
            sx={{ py: 1.5, px: 2 }}
          >
            <ListItemText
              primary={languages[locale]}
              sx={{
                "& .MuiListItemText-primary": {
                  fontWeight: locale === language ? 600 : 400,
                },
              }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
